/**
 * Fee-consent vocabulary shared by the API (audit payload) and the UI (consent copy).
 *
 * Bump CONSENT_TEXT_VERSION whenever any consent copy below changes materially, so the audit
 * record of "what the landlord agreed to" stays attributable to a specific wording.
 */
export const CONSENT_TEXT_VERSION = 'iter16-v2';
/** Consent copy: each states the amount ("$49.00") and that applicable sales tax is added. */
export const CONSENT_COPY = {
    listing_fee: (amount) => `I authorize Resida to charge ${amount} plus applicable sales tax to this card for this listing.`,
    listing_fee_renewal: (amount) => `I authorize Resida to charge ${amount} plus applicable sales tax to this card to renew this listing.`,
    agent_proration: (amount) => `I authorize Resida to charge ${amount} plus applicable sales tax to this card now (the prorated agent support amount), and the full monthly price on each following invoice.`,
};
//# sourceMappingURL=billing-consent.js.map